import { OrgTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadCollections = createAction('[Collection] Load Collections', props<{ username: string }>());
export const refreshCollections = createAction('[Collection] Refresh Collections', props<{ username: string }>());

export const loadCollectionsSuccess = createAction(
  '[Collection] Load Collections Success',
  props<{ collections: ReadonlyArray<OrgTypes.Collection> }>()
);

export const loadCollectionsFailure = createAction('[Collection] Load Collections Failure', props<{ error: any }>());
